const Analytics = {
    logEvent: (_name: string, _params?: { [key: string]: any }): void => {
        console.log('TODO: not implemented');
    },
};

export { Analytics };
